import React from 'react';
import { useRouter } from 'next/router';

export const useOpenJobDialog = () => {
  const router = useRouter();

  return React.useCallback(
    (jobId: string) => {
      const currentJobId = router.query.job;
      if (jobId !== currentJobId) {
        const newQuery = { ...router.query, job: jobId };
        router.push(
          { pathname: router.pathname, query: newQuery },
          undefined,
          { shallow: true, scroll: false } // Added scroll: false for instant navigation
        );
      }
    },
    [router]
  );
};
